export default "__VITE_ASSET__C5Dhry6U__"